module.exports = __webpack_public_path__ + "static/img/2.1c5e6b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/zh/2.png
// module id = AobV
// module chunks = 0